import React from 'react';

export const detectBrowserFeatures = () => {
  /* IE detection */
  const ie = detectIEVersion();
  if (ie !== false) {
    document.documentElement.className += ie < 12 ? ' ie' : ' edge';
  }
};

/**
 * Detect IE or Edge browser version (up to Edge 13)
 * @see {@link https://codepen.io/gapcode/pen/vEJNZN|CodePen}
 * @returns
 */
export function detectIEVersion() {
  const userAgent = window.navigator.userAgent;

  const msie = userAgent.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(
      userAgent.substring(msie + 5, userAgent.indexOf('.', msie)),
      10,
    );
  }

  const trident = userAgent.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = userAgent.indexOf('rv:');
    return parseInt(
      userAgent.substring(rv + 3, userAgent.indexOf('.', rv)),
      10,
    );
  }

  const edge = userAgent.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(
      userAgent.substring(edge + 5, userAgent.indexOf('.', edge)),
      10,
    );
  }

  // other browser
  return false;
}

export const setScrollRestorationToManual = () => {
  try {
    window.history.scrollRestoration = 'manual';
  } catch (e) {
    console.error(e);
  }
};

/**
 * Render this into the form to disable autofill in chrome.
 * This hack is suggested here https://stackoverflow.com/a/15917221
 */
export const renderFakeFieldsToDisableChromeAutofill = () => {
  return (
    <React.Fragment>
      <input
        style={{ display: 'none' }}
        type="text"
        name="fakeusernameremembered"
      />
      <input
        style={{ display: 'none' }}
        type="password"
        name="fakepasswordremembered"
      />
    </React.Fragment>
  );
};

export const isMobileBrowser = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
    navigator.userAgent,
  );
};

export const appendQueryParameter = (queryParam) =>
  `${window.location.pathname}${
    window.location.search ? `${window.location.search}&` : '?'
  }${queryParam}`;

export const getCurrentPath = () => window.location.pathname + '';

export const downloadCsv = (filename, rows) => {
  const csvContent = rows
    .map((cols) =>
      cols
        .map((col) => `"${col}"`)
        .join(',')
        .replace(/[\n\r]/g, ' | '),
    )
    .join('\n');
  const prefix = 'data:text/csv;charset=utf-8,';
  const encodedUri = prefix + encodeURIComponent(csvContent);
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', `${filename}.csv`);
  document.body.appendChild(link);
  link.click();
};

export const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};
